function init() {
  // Debounce helper
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Mega menu dropdowns - using js instead of css for accessibility
  const menuItems = document.querySelectorAll('.m-menu-desktop > .has-mega-menu > a');

  menuItems.forEach(link => {
    const parentLi = link.closest('li');
    const dropdownId = link.getAttribute('aria-controls');
    const dropdown = document.getElementById(dropdownId);

    // Initialize dropdown with closed state
    if (dropdown) {
      dropdown.classList.add('mega-menu-animated', 'mega-menu-closed');
      dropdown.hidden = false; // Remove hidden attribute permanently
    }

    // Toggle on Enter or Space
    link.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleDropdown(parentLi, dropdown, link);
      }
    });

    // Close on Escape from within dropdown
    dropdown?.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        closeDropdown(parentLi, dropdown, link);
      }
    });

    // Open on hover/focus
    link.addEventListener('mouseover', () => openDropdown(parentLi, dropdown));
    link.addEventListener('focus', () => openDropdown(parentLi, dropdown));
    
    // Also open on focusin to handle shift-tab navigation
    parentLi.addEventListener('focusin', () => openDropdown(parentLi, dropdown));

    // Close on mouse leave
    parentLi.addEventListener('mouseleave', () => closeDropdown(parentLi, dropdown, link));
    
    // Close on focus out (when focus leaves the mega menu area)
    parentLi.addEventListener('focusout', (e) => {
      // Use setTimeout to allow focus to move to the new element first
      setTimeout(() => {
        // Check if focus is still within the mega menu
        const focusedElement = document.activeElement;
        if (!parentLi.contains(focusedElement)) {
          closeDropdown(parentLi, dropdown, link);
        }
      }, 0);
    });
     
  });

  // Close when clicking outside any open dropdown
  document.addEventListener('click', e => {
    document.querySelectorAll('.m-menu-desktop > .has-mega-menu[aria-expanded="true"]').forEach(li => {
      const dropdown = li.querySelector('.mega-menu');
      const link = li.querySelector('a[aria-haspopup="true"]');
      if (!li.contains(e.target)) {
        closeDropdown(li, dropdown, link);
      }
    });
  });

  // Center all dropdowns initially on page load
  document.querySelectorAll('.m-menu-desktop > .has-mega-menu .mega-menu').forEach(dropdown => {
    centerDropdownInViewport(dropdown);
  });

  // Recenter dropdowns on window resize with debounce
  window.addEventListener('resize', debounce(() => {
    document.querySelectorAll('.m-menu-desktop > .has-mega-menu .mega-menu').forEach(dropdown => {
      // Force reflow before recalculating
      dropdown.style.left = '';
      dropdown.offsetHeight; // Force reflow
      centerDropdownInViewport(dropdown);
    });
  }, 150)); // Wait 150ms after resize stops

  function alignMegaMenuGroups(dropdown) {
    if (!dropdown) return;
    
    const columns = dropdown.querySelectorAll('.mega-menu__column');
    if (columns.length !== 2) return;
    
    const column1Groups = columns[0].querySelectorAll('.mega-menu__group');
    const column2Groups = columns[1].querySelectorAll('.mega-menu__group');
    
    // Reset heights first
    [...column1Groups, ...column2Groups].forEach(group => {
      group.style.height = '';
    });
    
    // Force a reflow to get natural heights
    dropdown.offsetHeight;
    
    // Match heights for each "row"
    const maxRows = Math.max(column1Groups.length, column2Groups.length);
    
    for (let i = 0; i < maxRows; i++) {
      const group1 = column1Groups[i];
      const group2 = column2Groups[i];
      
      if (group1 && group2) {
        const height1 = group1.offsetHeight;
        const height2 = group2.offsetHeight;
        const maxHeight = Math.max(height1, height2);
        
        group1.style.height = maxHeight + 'px';
        group2.style.height = maxHeight + 'px';
      }
    }
  }

  function openDropdown(li, dropdown) {
    if (!dropdown) return;
    
    // Clear any pending close timeout
    if (dropdown._closeTimeout) {
      clearTimeout(dropdown._closeTimeout);
      dropdown._closeTimeout = null;
    }

    li.setAttribute('aria-expanded', 'true');
    li.querySelector('a').setAttribute('aria-expanded', 'true');
    
    // Make visible first (in case it was pointer-events: none)
    dropdown.classList.remove('mega-menu-closed');
    
    // Force reflow to ensure transition happens
    dropdown.offsetHeight;
    
    // Align heights before showing
    alignMegaMenuGroups(dropdown);
    
    // Add open class for animation
    dropdown.classList.add('mega-menu-open');

    // Focus on first link inside the dropdown (optional)
    const firstLink = dropdown.querySelector('a');
    // Uncomment if you want auto-focus: firstLink?.focus();
  }

  function closeDropdown(li, dropdown, triggerLink) {
    if (!dropdown) return;
    
    li.setAttribute('aria-expanded', 'false');
    triggerLink.setAttribute('aria-expanded', 'false');
    
    // Remove open class to trigger closing animation
    dropdown.classList.remove('mega-menu-open');
    
    // After animation completes, add closed class to prevent interaction
    dropdown._closeTimeout = setTimeout(() => {
      dropdown.classList.add('mega-menu-closed');
      dropdown._closeTimeout = null;
    }, 0); // Match this to your CSS transition duration
  }

  function toggleDropdown(li, dropdown, triggerLink) {
    const isExpanded = li.getAttribute('aria-expanded') === 'true';
    isExpanded ? closeDropdown(li, dropdown, triggerLink) : openDropdown(li, dropdown);
  }

  function centerDropdownInViewport(dropdown) {
    if (!dropdown) return;

    const parentLi = dropdown.parentElement;
    if (!parentLi) return;

    // Force reflow to get fresh measurements
    dropdown.offsetHeight;

    const liRect = parentLi.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const dropdownWidth = dropdown.offsetWidth;

    const viewportCenterX = viewportWidth / 2;
    const offsetLeft = viewportCenterX - liRect.left - (dropdownWidth / 2);

    dropdown.style.left = `${offsetLeft}px`;
    dropdown.style.marginLeft = '0';

    parentLi.classList.remove('mega-disabled');
  }
}

export { init as default }